var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "State=On, Icon Type=Invoice"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9992 21V5C18.9992 3.9 18.0992 3 16.9992 3H6.99921C5.89921 3 4.99921 3.9 4.99921 5V21C4.99921 19.9 6.09921 19 7.29921 19C8.59921 19 9.59921 19.9 9.59921 21C9.59921 19.9 10.6992 19 11.8992 19C13.1992 19 14.1992 19.9 14.1992 21C14.1992 19.9 15.1992 19 16.4992 19C17.9992 19 18.9992 19.9 18.9992 21Z",
    fill: "white",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 11.0004H15",
    stroke: "#68A14B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 6.99963H15",
    stroke: "#68A14B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedInvoice);
export default __webpack_public_path__ + "static/media/selected-invoice.ae1075d675a72009cc1b64c912691bf8.svg";
export { ForwardRef as ReactComponent };